import { alertsAtom } from '@/atoms';
import ir3Logo from '@/svg/ir3Logo.svg';
import { getUser, notify, reviveDate } from '@/utils';
import { eventNotifications, platformApiRootUrl } from '@/utils/config';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';

export function useAccelerometerAlertStream() {
  const [, setAlerts] = useAtom(alertsAtom);
  const navigate = useNavigate();
  const user = getUser();

  useEffect(() => {
    if (!eventNotifications.accelerometerAlerts) {
      return;
    }

    const ctrl = new AbortController();

    fetchEventSource(`${platformApiRootUrl}/sse/accelerometer-alerts`, {
      headers: {
        authorization: `Bearer ${user?.access_token}`,
      },
      signal: ctrl.signal,
      onmessage(msg) {
        console.log('Received accelerometer alert:', msg);

        if (msg.event === 'insert') {
          const alert = JSON.parse(msg.data, reviveDate);

          notify(
            'Accelerometer Alert',
            {
              tag: alert.identifier,
              body: `${
                alert.driver
                  ? `${alert.driver.forenames} ${alert.driver.surname} (${alert.driver.collarNumber})`
                  : 'Unknown driver'
              } - ${alert.vehicle.registrationNumber} (${
                alert.vehicle.fleetNumber
              })`,
              icon: ir3Logo,
              timestamp: Math.floor(alert.time),
            },
            () => {
              navigate(`/live/events/${alert.identifier}`);
            },
          );

          setAlerts((alerts) => alerts.concat(alert));
        }

        if (msg.event === 'update') {
          const alert = JSON.parse(msg.data, reviveDate);

          if (alert.claimedBy) {
            setAlerts((alerts) =>
              alerts.filter((a) => a.identifier !== alert.identifier),
            );
          }
        }
      },
    });

    return () => {
      ctrl.abort();
    };
  }, [navigate, setAlerts, user?.access_token]);
}
